export const Brand = {
    name: 'EnfoMentis',
    displayName: 'EnfoMentis',
    tagline: 'Where Discipline Meets Discovery',
    shortName: 'EM',
    cachePrefix: 'em',
    domain: 'enfomentis.app',
    supportEmail: 'support@enfomentis.com',
    driveFolder: 'EnfoMentis',
    mfaIssuer: 'EnfoMentis',
    appUrl: 'https://enfomentis.app',
    devAppUrl: 'https://dev.enfomentis.app',
    adminUrl: 'https://admin.enfomentis.app',
    helpUrl: 'https://enfomentis.com/support',
};
//# sourceMappingURL=brand.js.map